import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TConfirmHideTutorialModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmHideTutorialModal: FC<TConfirmHideTutorialModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal isOpen={open} onClose={onClose} onOk={onConfirm} labelClose={"閉じる"} labelOk={"はい"} width={500}>
      <Stack mb={2} mt={2}>
        <Typography>この操作を続行すると、チュートリアルが表示されなくなります。続行してもよろしいですか？</Typography>
      </Stack>
    </Modal>
  );
};
